import { BREAKPOINT } from '../common/constants';

export function isMobile() {
  return !(typeof window !== 'undefined' && window.innerWidth >= BREAKPOINT);
}
